<template>
  <footer class="site-footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-10">
          <div class="row">
            <div class="col-md">
              <ul class="list-unstyled text-uppercase"
                  style="font-variant-numeric: normal;">
                <li class="list-item font-weight-medium"
                    v-bind:key="item.id"
                    v-for="item in catalogs">
                  <router-link class="list-item-link"
                               :to="{ name: 'catalog', params: { slug: item.slug } }">
                    <span v-html="item.title.rendered"></span>
                  </router-link>
                </li>
              </ul>
            </div>
            <div class="col-md">
              <ul class="list-unstyled text-light">
                <li>ZEE [typo]graphic design</li>
                <li>Voorhaven 27 b</li>
                <li class="font-variant: small-caps">3025 <span style="font-variant: small-caps">hc</span> Rotterdam</li>
              </ul>
            </div>
            <div class="col-md">
              <ul class="list-unstyled text-light">
                <li><a href="mailto:ontwerpers@zee.nl" class="text-light">ontwerpers@zee.nl</a></li>
                <li><a href="tel:010 476 85 21" class="text-light">010 476 85 21</a></li>
                <li><a href="tel:06 28 37 55 33" class="text-light">06 28 37 55 33</a></li>
              </ul>
            </div>
            <div class="col-md">
              <ul class="list-unstyled text-light">
                <li>design <router-link class="list-item-link text-light inverted"
                                        :to="{ name: 'page', params: { slug: infoPage.slug } }">ZEE</router-link></li>
                <li>development <a href="https://boldcode.nl"
                                   class="text-light"
                                   target="_blank">Boldcode</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'site-footer',
  computed: {
    ...mapState({
      catalogs: state => state.catalogs,
      options: state => state.options
    })
  },
  beforeMount () {
    if (this.options.info) {
      this.infoPage = this.$store.getters.getItemById('page', this.options.info)
    }
  }
}
</script>
